module.exports = __webpack_public_path__ + "img/m_pbsp.b5be90d8.png";